import React from 'react'

import { Spinner } from '@wartek-id/spinner'

import KinerjaSidebar from 'app/KinerjaShared/components/KinerjaSidebar'
import { usePenilikSummary } from 'app/KinerjaPenilikPegawaiPage/hooks/useSummary'
import CardSekolahBinaanEmpty from './components/CardSekolahBinaanEmpty'
import CardRHKAtasanNotExists from './components/CardRHKAtasanNotExists'
import CardPejabatPenilaiKinerja from './components/CardPejabatPenilaiKinerja'
import CardPerencanaan from './components/CardPerencanaan'
import SectionPelaksanaan from './components/SectionPelaksanaan'
import ResetButtons from 'app/KinerjaPenilikPegawaiPage/components/ResetButtons'
import { SyncToEkin } from 'app/KinerjaPenilikPegawaiPage/components/SyncToEkin'
import { usePenilikTrackEvent } from 'app/KinerjaPenilikPegawaiPage/hooks/usePenilikTrackEvent'

function PenilikPegawaiIndexPage() {
  const { summary, summaryFetchStatus, isPelaksanaanState } =
    usePenilikSummary()
  const hasSekolahBinaan = summary?.sekolahBinaanCount > 0
  const isRHKAtasanExists = Boolean(summary?.isRhkAtasanExists)

  const { trackEventBase } = usePenilikTrackEvent()

  React.useEffect(() => {
    trackEventBase('beranda', 'view')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="pl-64">
      <KinerjaSidebar sticky activeMenu="penilik-pegawai" />

      <div className="w-full gap-4 p-6">
        {summaryFetchStatus === 'loading' && (
          <div className="flex justify-center">
            <Spinner data-testid="loading-summary" />
          </div>
        )}

        {['success', 'error'].includes(summaryFetchStatus) && (
          <div className="w-full gap-4 space-y-4 xl:flex xl:space-y-0">
            {summaryFetchStatus === 'success' && !hasSekolahBinaan && (
              <CardSekolahBinaanEmpty />
            )}

            {((hasSekolahBinaan && isRHKAtasanExists) ||
              summary?.isRhkAtasanExists === undefined) && (
              <div className="space-y-3 grow">
                <CardPerencanaan
                  status={summary?.perencanaanStatus}
                  isPelaksanaanState={isPelaksanaanState}
                />
                <SectionPelaksanaan
                  isPelaksanaanState={isPelaksanaanState}
                  summary={summary}
                />
              </div>
            )}

            {summaryFetchStatus === 'success' &&
              hasSekolahBinaan &&
              !isRHKAtasanExists && <CardRHKAtasanNotExists />}

            <div className="space-y-5">
              <SyncToEkin
                isError={summaryFetchStatus === 'error'}
                perencanaanStatus={summary?.perencanaanStatus}
                ekinSyncErrorMessage={summary?.ekinSyncErrorMessage}
                ekinSyncStatus={summary?.ekinSyncStatus}
              />

              {hasSekolahBinaan && (
                <CardPejabatPenilaiKinerja
                  name={summary?.pejabatPenilaiKinerja}
                />
              )}
            </div>
          </div>
        )}
      </div>

      {/* Display the Reset button only if the toggle is enabled */}
      <ResetButtons />
    </div>
  )
}

export default PenilikPegawaiIndexPage
